import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { useCarrierStatus } from '@/api/domains/carriers';
import { InPostMark } from '@/components/inpost-logo';
import { PageHeader } from '@/components/layout/page-header';
import { usePageTitle } from '@/components/layout/page-title';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';

export function CarriersIndexPage() {
  const { t } = useTranslation('carriers');
  usePageTitle(t('title'));
  const inpostStatus = useCarrierStatus('inpost');

  const status = inpostStatus.data;
  const statusKey = !status
    ? 'disconnected'
    : status.needs_organization_selection
      ? 'needsOrganization'
      : status.status === 'connected'
        ? 'connected'
        : 'disconnected';
  const isConnected = statusKey === 'connected';

  return (
    <div className="space-y-6">
      <PageHeader title={t('title')} subtitle={t('subtitle')} />

      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
        <Card>
          <CardHeader className="items-start">
            <div className="mb-2 flex h-12 w-12 items-center justify-center rounded-md bg-muted">
              <InPostMark variant="white-bg" className="h-7 w-auto" />
            </div>
            <CardTitle className="flex items-center gap-2">
              InPost
              {inpostStatus.isLoading ? (
                <Skeleton className="h-5 w-20" />
              ) : (
                <Badge variant={isConnected ? 'default' : 'secondary'}>
                  {t(`status.${statusKey}`)}
                </Badge>
              )}
            </CardTitle>
            <CardDescription>
              {inpostStatus.isLoading ? (
                <Skeleton className="h-4 w-32" />
              ) : (
                (status?.organization_name ?? '-')
              )}
            </CardDescription>
          </CardHeader>
          <CardContent>
            <Button asChild variant="outline" className="w-full">
              <Link to="/authorization">
                {t('manage')}
                <ArrowRight className="ml-2 h-4 w-4" />
              </Link>
            </Button>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
